import React from 'react'
import { useNavigate } from 'react-router-dom'
import { authAPI } from '../utils/api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartLine, faHouse, faRightFromBracket, faShieldHalved, faUserGear } from '@fortawesome/free-solid-svg-icons'

function Header({ user, onLogout }) {
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await authAPI.logout()
    } catch (error) {
      console.error('Logout error:', error)
    } finally {
      onLogout()
      navigate('/login')
    }
  }

  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <div className="h-11 w-11 rounded-2xl bg-gradient-to-br from-blue-600 via-indigo-600 to-purple-600 text-white flex items-center justify-center shadow-lg">
            <FontAwesomeIcon icon={faUserGear} />
          </div>
          <div className="min-w-0">
            <h1 className="text-lg md:text-2xl font-black text-slate-900 truncate">
              SCiUS KKU 15 Pre-Camp
            </h1>
            {user && (
              <p className="text-slate-600 text-sm truncate">
                ยินดีต้อนรับ {user.name} ({user.nickname})
              </p>
            )}
          </div>
        </div>
        {user && (
          <div className="flex items-center gap-2 md:gap-3 flex-wrap justify-end">
            <span className="inline-flex items-center gap-2 px-3 py-1 bg-sky-100 text-sky-800 rounded-full text-sm font-semibold">
              <FontAwesomeIcon icon={faShieldHalved} />
              {user.role === 'staff_station' ? 'Staff + Station' : user.role}
            </span>
            <button
              onClick={() => navigate(user.role === 'admin' ? '/admin' : '/dashboard')}
              className="btn btn-secondary btn-sm inline-flex items-center gap-2"
            >
              <FontAwesomeIcon icon={faHouse} />
              Home
            </button>
            <button
              onClick={() => navigate('/leaderboard')}
              className="btn btn-secondary btn-sm inline-flex items-center gap-2"
            >
              <FontAwesomeIcon icon={faChartLine} />
              Board
            </button>
            <button
              onClick={handleLogout}
              className="btn btn-secondary btn-sm inline-flex items-center gap-2"
            >
              <FontAwesomeIcon icon={faRightFromBracket} />
              Logout
            </button>
          </div>
        )}
      </div>
    </header>
  )
}

export default Header
